import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import type { ForecastAnomaly } from '../types/forecast.types';

interface Props {
  open: boolean;
  mode: 'approve' | 'dismiss';
  alert: ForecastAnomaly | null;
  busy?: boolean;
  onClose: () => void;
  onConfirm: (note: string) => void;
}

export function ForecastInboxActionModal({
  open,
  mode,
  alert,
  busy,
  onClose,
  onConfirm,
}: Props) {
  const { t } = useTranslation();
  const [note, setNote] = useState('');

  if (!open || !alert) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-md rounded-lg bg-white p-5 shadow-lg">
        <h3 className="text-sm font-semibold text-gray-900">
          {mode === 'approve'
            ? t('forecastPage.inboxModal.approveTitle')
            : t('forecastPage.inboxModal.dismissTitle')}
        </h3>
        <p className="mt-1 text-xs text-gray-600">{alert.title}</p>
        <label className="mt-4 block text-xs text-gray-500">
          {t('forecastPage.inboxModal.note')}
          <textarea
            className="mt-1 w-full rounded-md border border-gray-300 px-2 py-1.5 text-sm"
            rows={3}
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
        </label>
        <div className="mt-4 flex justify-end gap-2">
          <button
            type="button"
            className="rounded-md border border-gray-300 px-3 py-1.5 text-sm"
            disabled={busy}
            onClick={onClose}
          >
            {t('common.cancel')}
          </button>
          <button
            type="button"
            className="rounded-md bg-stocker-primary px-3 py-1.5 text-sm text-white disabled:opacity-50"
            disabled={busy}
            onClick={() => onConfirm(note)}
          >
            {t('common.save')}
          </button>
        </div>
      </div>
    </div>
  );
}
